export default "__VITE_ASSET__BSXP9MB9__"